module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./RefundDetailView.js"));
	}, "RefundDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RefundDetailView!./src/pages/Shop/Member/Wallet/Refund/RefundDetail/RefundDetailView.js
// module id = 2006
// module chunks = 367